import axios from './axios'
import { CreateTerminalPaymentRequest } from './types'

export const createTerminalPayment = (data: CreateTerminalPaymentRequest) => {
  return axios.post<{ paymentId: string }>('/terminal-payments', data)
}
